export default __webpack_public_path__ + "static/media/ball1.1f9dc715.webp";